<template>
	<footer>
		<div class="footer-container-top padding-top-70 padding-bottom-70">
			<div class="container">
				<div class="row">
					<div class="col-md-4 col-sm-12 col-xs-12">
						<footer-site-info v-once />
					</div>
					<div class="col-md-offset-1 col-md-3 col-sm-12 col-xs-12">
						<footer-links v-if="!isMobile()" />
						<footer-newsletter v-if="isMobile()" />
					</div>
					<div class="col-md-4 col-sm-12 col-xs-12">
						<footer-links v-if="isMobile()" />
						<footer-newsletter v-if="!isMobile()" />
					</div>
				</div>
			</div>
		</div>
		<div class="footer-container-bottom">
			<div class="container">
				<div class="row">
					<div class="col-md-5 hidden-xs hidden-sm text-left">
						<footer-credits v-once />
					</div>
					<div class="col-md-2 text-center back-top">
						<footer-scroll-to-top v-once />
					</div>
					<div class="col-md-5 text-right">
						<socials-links component-class="list-none social-icon-1" />
					</div>
					<div class="col-md-5 hidden-md hidden-lg text-center">
						<footer-credits v-once />
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import Helpers from '@/mixins/Helpers'
import FooterCredits from '@/components/footer/FooterCredits'
import FooterScrollToTop from '@/components/footer/FooterScrollToTop'
import FooterSiteInfo from '@/components/footer/FooterSiteInfo'

const FooterLinks = () => import(/* webpackPrefetch: true */ '@/components/footer/FooterLinks')
const FooterNewsletter = () => import(/* webpackPrefetch: true */ '@/components/footer/FooterNewsletter')
const SocialsLinks = () => import(/* webpackPrefetch: true */ '@/components/partials/SocialsLinks')

export default {
	name: 'FooterContainer',
	components: {
		FooterCredits,
		FooterScrollToTop,
		FooterSiteInfo,
		FooterLinks,
		FooterNewsletter,
		SocialsLinks,
	},
	mixins: [Helpers],
}
</script>



// WEBPACK FOOTER //
// src/components/footer/FooterContainer.vue